import {Theme} from '@emotion/react';
import {BrownFontStack} from '../Typography/constants';

export const getMainFont = (theme: Theme): string => {
  return theme?.fonts?.main ?? BrownFontStack;
};
